export default () => ({
  onboard: null,
  testMode: false,
  products: [
    { text: 'Annual Pro', value: 'annual', size: 'lg', required: true },
    { text: 'Monthly Pro', value: 'monthly', size: 'lg', required: true },
    { text: 'Monthly Pro w/ALLDATA', value: 'pro', size: 'lg', required: true }
    // { text: 'Per Event', value: 'per', size: 'lg', required: true }
  ],
  disable: false
})



// WEBPACK FOOTER //
// ./src/store/modules/onboard/state.js